import _defineProperty from "/home/jenkins/agent/workspace/ite-static-site-generator_master/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import './index.css';
import React from 'react';
import cx from 'classnames';
var styles = {
  "component": "component--IuaxP",
  "isActive": "isActive--c9YBf"
};
var Type = {
  BUTTON: 'button',
  SUBMIT: 'submit'
};
var Tag = {
  BUTTON: 'button',
  DIV: 'div'
};
var ClickableIcon = function ClickableIcon(_ref) {
  var _ref$type = _ref.type,
    _type = _ref$type === void 0 ? Type.BUTTON : _ref$type,
    _ref$name = _ref.name,
    _name = _ref$name === void 0 ? undefined : _ref$name,
    onClick = _ref.onClick,
    children = _ref.children,
    _ref$isActive = _ref.isActive,
    _isActive = _ref$isActive === void 0 ? false : _ref$isActive,
    _ref$isDisabled = _ref.isDisabled,
    _isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
    _ref$dataId = _ref.dataId,
    _dataId = _ref$dataId === void 0 ? undefined : _ref$dataId,
    _ref$tag = _ref.tag,
    _tag = _ref$tag === void 0 ? Tag.BUTTON : _ref$tag,
    ariaLabel = _ref.ariaLabel;
  if (_tag === Tag.DIV) {
    return /*#__PURE__*/React.createElement("div", {
      className: cx(styles.component, _defineProperty({}, styles.isActive, _isActive)),
      onClick: onClick,
      "data-id": _dataId,
      "data-qa": "clickable-icon",
      role: "button",
      tabIndex: 0
    }, children);
  }
  return /*#__PURE__*/React.createElement("button", {
    className: cx(styles.component, _defineProperty({}, styles.isActive, _isActive)),
    onClick: onClick,
    "data-id": _dataId,
    "data-qa": "clickable-icon",
    name: _name
    // eslint-disable-next-line react/button-has-type
    ,

    type: _type,
    disabled: _isDisabled,
    "aria-label": ariaLabel
  }, children);
};
ClickableIcon.Type = Type;
ClickableIcon.Tag = Tag;
export default ClickableIcon;